import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { getLabelId } from '../utils/aria';
import AccordionHeader from './AccordionHeader';
import { AccordionPanelWrapper } from './styles';
import Collapse from '../Collapse';
import { Padding } from '../Spacing';
const AccordionPanel = ({
  header,
  children,
  id,
  defaultOpen = false,
  onToggle,
  openItems = [],
  renderHeader,
  headerProps,
  contentPadding = 'md',
  ...props
}) => {
  const accordionId = useMemo(() => id || getLabelId('urc-accordion'), [id]);
  const isOpen = openItems.includes(accordionId);
  useEffect(() => {
    if (defaultOpen && openItems.length === 0) {
      onToggle(accordionId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleToggle = () => onToggle(accordionId);
  const content = typeof children === 'function' ? children({
    onToggle: handleToggle,
    isOpen,
    accordionId
  }) : children;
  return /*#__PURE__*/React.createElement(AccordionPanelWrapper, props, /*#__PURE__*/React.createElement(AccordionHeader, _extends({
    isOpen: isOpen,
    accordionId: accordionId,
    onClick: handleToggle,
    renderHeader: renderHeader
  }, headerProps), header), /*#__PURE__*/React.createElement(Collapse, {
    "aria-labelledby": `${accordionId}Header`,
    id: accordionId,
    isOpen: isOpen,
    role: "region"
  }, /*#__PURE__*/React.createElement(Padding, {
    top: "none",
    all: contentPadding
  }, content)));
};
AccordionPanel.propTypes = {
  header: PropTypes.node,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  defaultOpen: PropTypes.bool,
  openItems: PropTypes.arrayOf(PropTypes.string),
  renderHeader: PropTypes.func
};
export default AccordionPanel;
//# sourceMappingURL=AccordionPanel.js.map